<template>
    <div
        class="program-item-bar"
        :style="barValue"
    >
        <div v-if="item.hasUpdates" class="indicator" />
        <div class="title-row">
            <div class="type-icon" :style="typeIcon"></div>
            <div class="title">
                {{ title }}
            </div>
        </div>
        <div class="info-row">
            {{ dateInterval }}
        </div>
    </div>
</template>

<script>
import { programTypes } from "./consts";
import { getFormattedTimeInterval } from "@/tools/moment-date";
import { getPastPartByPercent } from "./helpers";

export default {
    name: "ProgramItemBarMobile",

    props: {
        item: {
            type: Object,
            default: () => {},
        },
    },

    computed: {
        title() {
            return [this.item.programName, this.item.moduleName]
                .filter(v => v)
                .join('. ')
            ;
        },

        programType() {
            return this.item.educationType;
        },

        startDate() {
            return this.item.moment ? this.item.moment.start : null;
        },

        endDate() {
            return this.item.moment ? this.item.moment.end : null;
        },

        typeIcon() {
            const iconType = this.item.status === 'completed' ? 'completeIcon' : 'icon';
            return {
                'background-image': `url(${ programTypes[this.programType][iconType] })`,
            };
        },

        progressValue() {
            const start = this.startDate;
            const end = this.endDate;
            return getPastPartByPercent(start, end);
        },

        barValue() {
            return {
                background: `linear-gradient(to right, ${
                    programTypes[this.programType].bgColor
                } ${ this.progressValue }%, #FFFFFF ${ this.progressValue }%)`,
            };
        },

        dateInterval() {
            return getFormattedTimeInterval(this.startDate, this.endDate, 'DD MMMM, YYYY');
        },
    },
};
</script>

<style lang="scss" scoped>
    @import "~@/styles/rem";

    .program-item-bar {
        box-sizing: border-box;
        position: relative;
        width: 100%;
        height: 72px;
        padding: 14px;
        border: 1px solid #E3E9F0;
        border-radius: 4px;
        background-color: #ffffff;
        cursor: pointer;

        @include on-xs {
            height: auto;
            padding: 10px 12px;
        }

        .indicator {
            position: absolute;
            top: -5px;
            left: 5px;
            z-index: 1;
            width: 10px;
            height: 10px;
            background: #D1004A;
            box-shadow: 0 2px 8px rgba(155, 161, 166, 0.23626);
            border-radius: 50%;
        }

        .title-row {
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 3px;

            @include on-xs {
                margin-bottom: 0;
            }
        }

        .title {
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            color: #2A2626;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;

            @include on-xs {
                font-size: 12px;
                line-height: 16px;
                white-space: normal;
            }
        }

        .type-icon {
            flex: 0 0 auto;
            width: 22px;
            height: 22px;
            margin-right: 8px;
            background: no-repeat center/cover;
        }

        .info-row {
            margin-left: 30px;
            font-size: 14px;
            line-height: 20px;
            color: rgba(42, 38, 38, 0.8);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;

            @include on-xs {
                font-size: 12px;
                line-height: 16px;
            }
        }
    }
</style>